import { render, staticRenderFns } from "./PatientHelp.vue?vue&type=template&id=45e63872&"
import script from "./PatientHelp.vue?vue&type=script&lang=js&"
export * from "./PatientHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports